// Date/time formatting helpers — display only (no business logic)

const FR_MONTHS_SHORT = [
  'janv.', 'févr.', 'mars', 'avril', 'mai', 'juin',
  'juill.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'
];

/**
 * "2026-06-10T16:15" or "2026-06-10T16:15:00" → "10 juin · 16h15"
 * Accepts ISO datetime strings (with or without seconds). Returns "" on bad input.
 */
export function formatStopDateTime(value) {
  if (!value) return '';
  try {
    // Avoid timezone shifts: read parts directly from the string instead of new Date(value)
    const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (!m) return value;
    const [, , monthStr, dayStr, h, min] = m;
    const monthIdx = parseInt(monthStr, 10) - 1;
    const day = parseInt(dayStr, 10);
    const monthLabel = FR_MONTHS_SHORT[monthIdx] || monthStr;
    return `${day} ${monthLabel} · ${h}h${min}`;
  } catch {
    return value;
  }
}

/**
 * "2026-06-10" → "10 juin"
 */
export function formatShortDate(value) {
  if (!value) return '';
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return value;
  const [, , monthStr, dayStr] = m;
  const monthIdx = parseInt(monthStr, 10) - 1;
  const day = parseInt(dayStr, 10);
  return `${day} ${FR_MONTHS_SHORT[monthIdx] || monthStr}`;
}
